import type { CheckoutUrlRootBuilder } from './CheckoutUrlRootBuilder';

/** Base for the seller-backed intents — every one targets a creator. */
export class StoreScopedIntentBuilder {
  constructor(protected readonly root: CheckoutUrlRootBuilder) {}

  /**
   * Identify the creator by public `url_code` (e.g. `andy.us1`) — the ONLY creator
   * identifier a checkout understands, resolved to the creator server-side. Required for
   * every seller-backed intent.
   */
  urlCode(urlCode: string): this {
    this.root.param('c', urlCode);
    return this;
  }
}
